import { jsx } from "react/jsx-runtime";
import { Icon } from "@blueprintjs/core";
import React from "react";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
import { PartTagSearch } from "../helperComponents/partTagSearch";
export default connectToEditor(
  ({ annotationVisibility = {}, toolBar = {} }) => {
    return {
      toggled: annotationVisibility.parts,
      isOpen: toolBar.openItem === "partTool"
    };
  }
)(({
  allPartTags,
  editTagsLink,
  toolbarItemProps,
  toggled,
  annotationVisibilityToggle,
  isOpen
}) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { icon: "doughnut-chart" }),
        onIconClick: function() {
          annotationVisibilityToggle("parts");
        },
        toggled,
        editTagsLink,
        allPartTags,
        tooltip: "Show parts",
        tooltipToggled: "Hide parts",
        noDropdownIcon: !allPartTags,
        Dropdown: PartTagSearch,
        dropdowntooltip: (!isOpen ? "Show" : "Hide") + " Part Options",
        ...toolbarItemProps
      }
    }
  );
});
